import React, { FC, useContext, useEffect } from 'react'

import { Context } from './Context'

interface Props {
  className?: string
  handleValid?: () => void
  label?: string
  placeholder?: string
  style?: string
}

export const CVVInput: FC<Props> = ({ className, label = 'CVV', placeholder = 'CVV', style = '', handleValid }) => {
  const { formId, onField, setLabel, setPlaceholder, setStyle } = useContext(Context)
  useEffect(
    () =>
      onField('cvv', (type, _, inputProperties) => {
        if (type === 'input' && inputProperties.validCvv) {
          handleValid?.()
        }
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [onField],
  )

  useEffect(() => {
    setLabel('cvv', label)
  }, [label, setLabel])

  useEffect(() => {
    setPlaceholder('cvv', placeholder)
  }, [placeholder, setPlaceholder])

  useEffect(() => {
    setStyle('cvv', style)
  }, [style, setStyle])

  return <div className={className} id={`${formId}-spr-cvv`}></div>
}
